import { render, staticRenderFns } from "./editAddress.vue?vue&type=template&id=0a620982&scoped=true"
import script from "./editAddress.vue?vue&type=script&lang=js"
export * from "./editAddress.vue?vue&type=script&lang=js"
import style0 from "./editAddress.vue?vue&type=style&index=0&id=0a620982&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a620982",
  null
  
)

export default component.exports